import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import WorkoutBuilder from '../components/workout/WorkoutBuilder';
import Icon from '../components/shared/Icon';
import './WorkoutBuilderPage.css';

export default function WorkoutBuilderPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [saved, setSaved] = useState(false);

  const prefillDate = searchParams.get('date') || '';

  function handleSave(workout) {
    // In production: POST to API, then navigate
    console.log('[fitndex] Workout saved:', workout);
    setSaved(true);
    setTimeout(() => navigate('/app/workouts'), 1200);
  }

  return (
    <div className="workout-builder-page">
      <div className="workout-builder-page__header">
        <button
          className="workout-builder-page__back"
          onClick={() => navigate(-1)}
          type="button"
          aria-label="Go back"
        >
          <Icon name="back" size={16} /> Back
        </button>
        <h1 className="workout-builder-page__title">Build Workout</h1>
      </div>

      {saved ? (
        <div className="workout-builder-page__saved anim-fade-in-scale">
          <span className="workout-builder-page__saved-icon"><Icon name="check" size={48} /></span>
          <p>Workout saved!</p>
        </div>
      ) : (
        <WorkoutBuilder onSave={handleSave} initial={prefillDate ? { scheduledDate: prefillDate } : undefined} />
      )}
    </div>
  );
}
